import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, tap, catchError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { EmployeeAuthService } from './employee-auth.service';
import { StorageService } from './storage.service';
import { Employee } from '../models';

interface AutoLoginResponse {
  success: boolean;
  employee: Employee;
  token: string;
  message: string;
}

/**
 * Servicio para manejar el auto-login de owners a sus tenants
 * Valida el token del owner y crea una sesión de empleado automáticamente
 */
@Injectable({
  providedIn: 'root'
})
export class AutoLoginService {

  constructor(
    private http: HttpClient,
    private employeeAuthService: EmployeeAuthService,
    private storage: StorageService
  ) {}

  /**
   * Procesa el auto-login usando el token del owner
   * @param ownerToken Token del owner para validar
   * @returns Observable con la respuesta del backend
   */
  processAutoLogin(ownerToken: string): Observable<AutoLoginResponse> {
    console.log('🔑 AutoLoginService - Procesando auto-login...');
    console.log('🔑 Owner Token:', ownerToken.substring(0, 20) + '...');
    console.log('📍 URL:', `${environment.apiUrl}/tenant/auth/auto-login`);
    
    return this.http.post<AutoLoginResponse>(
      `${environment.apiUrl}/tenant/auth/auto-login`,
      { owner_token: ownerToken }
    ).pipe(
      tap(response => {
        console.log('📦 Respuesta del backend:', response);
        
        if (response.success && response.employee && response.token) {
          console.log('✅ Guardando sesión de empleado...');
          console.log('👤 Empleado:', response.employee);
          console.log('🔑 Token empleado:', response.token.substring(0, 20) + '...');
          
          // Guardar la sesión del empleado usando EmployeeAuthService
          // Esto actualiza tanto el storage como el BehaviorSubject
          this.employeeAuthService.setEmployeeToken(response.token);
          this.employeeAuthService.setEmployee(response.employee);
          
          // Si el empleado es también owner, guardar el token del owner
          if (response.employee.is_owner && response.employee.owner_data?.owner_token) {
            console.log('👑 Es owner, guardando owner_token...');
            console.log('🔑 Owner token:', response.employee.owner_data.owner_token.substring(0, 20) + '...');
            this.storage.setToken(response.employee.owner_data.owner_token);
          }
          
          console.log('✅ Sesión guardada exitosamente y componentes notificados');
        } else {
          console.warn('⚠️ Respuesta sin success o datos incompletos');
        }
      }),
      catchError(error => {
        console.error('❌ Error en processAutoLogin:', error);
        console.error('Status:', error.status);
        console.error('Error completo:', error);
        throw error;
      })
    );
  }
}
